import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { BrainImage } from "@/types";

export function useBrainImages(): UseQueryResult<BrainImage[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("brainImages"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<BrainImage[]>("/brain-images");
    },
    enabled: !!session,
  });
}

export function useBrainImage(id: string | undefined): UseQueryResult<BrainImage> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: id ? queryKeys.detail("brainImages", id) : ["resources", "brainImages", "_invalid"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<BrainImage>(`/brain-images/${id}`);
    },
    enabled: !!id && !!session,
  });
}
